import { combineReducers } from "redux";
import { AnyAction, Reducer } from "@reduxjs/toolkit";
// import { persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";

import authReducer from "./auth";
import appReducer from "./app";
import modalReducer from "./modal";
import toastReducer from "./toast";
import themeReducer from "./theme";

// const persistConfig = {
//     key: "root",
//     storage,
// };

// const authPersistedReducer = persistReducer(persistConfig, appReducer);
export * from "./app";
export * from "./modal";
export * from "./auth";
export * from "./toast";
export * from "./theme";

const productReducer = combineReducers({
    app: appReducer,
    modal: modalReducer,
    auth: authReducer,
    toast: toastReducer,
    theme: themeReducer,
});

export type RootState = ReturnType<typeof productReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
    if (action.type === "RESET") {
        // reset state
        state = {} as RootState;
        // reset local storage
        localStorage.clear();
    }
    return productReducer(state, action);
};
export default rootReducer;
